import { z } from 'zod';

const triggerSchema = z
  .object({
    applyToAll: z.boolean().optional(),
    context: z.object({
      marketplaces: z.string().array(),
      consumerChannels: z
        .object({ id: z.string(), name: z.string() })
        .array()
        .nonempty({ message: 'Please select at least one channel!' }),
      navigationType: z
        .string()
        .array()
        .nonempty({ message: 'Please select at least one navigation type!' }),
    }),
    queries: z
      .object({
        classifications: z
          .object({
            classificationValues: z.string().array(),
            mode: z.string(),
          })
          .array(),
        keywords: z
          .object({ searchTerm: z.string(), mode: z.string() })
          .array(),
      })
      .optional(),
  })
  .superRefine((input, ctx) => {
    const hasCF =
      input.queries &&
      input.queries.classifications &&
      input.queries.classifications.length > 0;
    const hasKY =
      input.queries &&
      input.queries.keywords &&
      input.queries.keywords.length > 0;
    if (input.applyToAll && !!input.queries) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'No trigger should be added when "applyToAll" is checked',
      });
    }
    if (!input.applyToAll && !hasCF && !hasKY) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please add a least one trigger concept/keyword',
      });
    }
  });
const boostSchema = z
  .object({
    type: z.string(),
    value: z.string().optional(),
    multiValue: z.string().array().optional(),
    relation: z.string(),
  })
  .superRefine((input, ctx) => {
    if (!!input.value && !!input.multiValue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Either "value" or "multiValue" should be required',
      });
    }
    if (!input.value && !input.multiValue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'You cannot have both "value" and "multiValue"',
      });
    }
  });
const burySchema = z
  .object({
    type: z.string().min(1),
    value: z.string().optional(),
    multiValue: z.string().array().optional(),
    relation: z.string(),
  })
  .superRefine((input, ctx) => {
    if (!!input.value && !!input.multiValue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Either "value" or "multiValue" should be required',
      });
    }
    if (!input.value && !input.multiValue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'You cannot have both "value" and "multiValue"',
      });
    }
  });

export const RankingRulePayloadSchema = z
  .object({
    name: z.string().min(1, { message: 'Should have name!' }),
    strategy: z.string().min(1, { message: 'Should have strategy!' }),
    priority: z
      .number()
      .min(0, { message: 'priority should be positive number!' }),
    startDate: z.string().datetime({ message: 'Please select start date!' }),
    endDate: z.string().datetime({ message: 'Please select end date!' }),
    trigger: triggerSchema,
    boosts: boostSchema.array().optional(),
    buries: burySchema.array().optional(),
  })
  .superRefine((input, ctx) => {
    const noBoosts =
      !input.boosts || (input.boosts && input.boosts.length === 0);
    const noBuries =
      !input.buries || (input.buries && input.buries.length === 0);
    if (noBoosts && noBuries) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Either "boosts" or "buries" should be required',
        path: ['boosts'],
      });
    }
  });

export const validateRankingRulePayload = (payload: any) => {
  return RankingRulePayloadSchema.safeParse(payload);
};
